import React, { useEffect, useState } from 'react';
import CustomModal from '../../../util_components/custom_modal';
import AdvisorHistoryTables from './AdvisorHistoryTables';
import { apiErrorReason, fetchHistory } from './api';
import { SHARED_STYLES } from '../styles';
import type { History } from './types';

const { MUTED } = SHARED_STYLES;

interface Props {
  student: { uuid: string; name: string } | null;
  onClose: () => void;
}

// Mounted only while open, so every open reloads the history.
function HistoryBody({ studentUuid }: { studentUuid: string }) {
  const [data, setData] = useState<History | null>(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let live = true;
    fetchHistory(studentUuid)
      .then((d) => live && setData(d))
      .catch((e) => live && setError(apiErrorReason(e, 'Failed to load history')));
    return () => {
      live = false;
    };
  }, [studentUuid]);
  if (error) {
    return (
      <p role="alert" className="text-sm" style={{ color: 'var(--state-error)' }}>
        {error}
      </p>
    );
  }
  if (!data) {
    return (
      <p className="text-sm" style={MUTED}>
        Loading history…
      </p>
    );
  }
  return <AdvisorHistoryTables data={data} />;
}

// Advisor history popup for the student profile.
function AdvisorHistoryModal({ student, onClose }: Props) {
  return (
    <CustomModal
      show={!!student}
      close={onClose}
      title={student ? `Advisor history: ${student.name}` : 'Advisor history'}
      inner_style={{ width: 'min(960px, 96vw)', borderRadius: 12 }}
    >
      {student ? (
        <div role="dialog" aria-label={`Advisor history: ${student.name}`}>
          <HistoryBody key={student.uuid} studentUuid={student.uuid} />
        </div>
      ) : null}
    </CustomModal>
  );
}

export default AdvisorHistoryModal;
